import lib from "zeta-dom";
const { isCssUrlValue, parseCSS, runCSSTransition } = lib.css;
export { isCssUrlValue, parseCSS, runCSSTransition };